/**
 * Names of table edit features
 */
export type TableEditFeatureName =
    | 'HorizontalTableInserter'
    | 'VerticalTableInserter'
    | 'TableMover'
    | 'TableResizer'
    | 'TableSelector'
    | 'CellResizer'
    | 'TableRowSelector'
    | 'TableColumnSelector';
